export interface IInfoMessagesState {
    currentMessageId: string | null;
}

export const defaultInfoMessagesState: IInfoMessagesState = Object.freeze({
    currentMessageId: null,
});
